import { utils } from "../helper";


import { useEffect } from "react";

export const Chat = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      const s1 = document.createElement("script");
      s1.async = true;
      s1.src = "https://embed.tawk.to/64f886cdb2d3e13950ee4afd/1h9lct5is";
      s1.charset = "UTF-8";
      s1.setAttribute("crossorigin", "*");
      document.body.appendChild(s1);
    }, 3000);
  
    return () => clearTimeout(timer);
  }, []);
};


export const BreakPoints = {
  500: {
    slidesPerView: 1,
    spaceBetween: 20,
  },
  600: {
    slidesPerView: 2,
    spaceBetween: 20,
  },
  768: {
    slidesPerView: 2,
    spaceBetween: 20,
  },
  992: {
    slidesPerView: 3,
    spaceBetween: 20,
  },
};

export const achievementData = [
  {
    targetNumber: 35,
    label: "Happy Clients",
    logo: utils.happyClients(60, 60),
  },
  {
    targetNumber: 65,
    label: "Success Projects",
    logo: utils.ourExperts(54, 58),
  },
  {
    targetNumber: 15,
    label: "Our Experts",
    logo: utils.yearofExperience(60, 60),
  },
  {
    targetNumber: 11,
    label: "Years of Experience",
    logo: utils.achievementExperience(54, 58),
  },
];
